class CreateTeam {
    constructor() {
        this.initGatewaySelect();
        this.createTeamFormValidation();
    }
    initGatewaySelect(){
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('#frm-createTeamForm-createTeamForm select[name=serverLocation]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
    }
    createTeamFormValidation(){
        let form = document.getElementById('frm-createTeamForm-createTeamForm');
        if(form){
            let submitButton = document.getElementById('create_team_form_submit');

            form.querySelector('input[name=OrgName]').addEventListener('input', function (e) {
                $(this).val(function () {
                    return this.value.replace(/\s+/g, '-');
                });
            });

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'OrgName': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^[a-zA-Z0-9\-]*$/,
                                    message: 'Allowed characters: a-z, A-Z, 0-9 and -',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=createTeamForm-checkTeamName',
                                }
                            }
                        },
                        'serverLocation': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                OrgName: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        })
                    }
                }
            ).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
}
window.CreateTeam = CreateTeam;